import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

export const GlobalStyles = createGlobalStyle`
  /* Reset and base styles */
  body {
    font-family: 'Inria Sans', sans-serif !important;
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: ${theme.colors.black};
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }

  /* Links */
  a {
    color: ${theme.colors.gold};
  }

  /* Icon button styling */
  button.btn-icon {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 12px;
    width: 48px;
    height: 48px;
    border-radius: 100px;
    fill: ${theme.colors.gold};
  }

  button.btn-icon.hidden {
    opacity: 0;
  }

  button.btn-icon:hover {
    background-color: ${theme.colors.bgDarker};
  }

  /* Tooltip system for buttons with data-tooltip attribute */
  button[data-tooltip] {
    position: relative;
  }

  button[data-tooltip]::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%) translateY(-8px);
    background: ${theme.colors.overlayDark};
    color: ${theme.colors.white};
    padding: ${theme.spacing.xs} ${theme.spacing.sm};
    border-radius: ${theme.borderRadius.sm};
    white-space: nowrap;
    opacity: 0;
    pointer-events: none;
    transition: opacity ${theme.transitions.fast};
    z-index: ${theme.zIndex.tooltip};
  }

  button[data-tooltip]:hover::after {
    opacity: 1;
  }

  /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.black};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.gray100};
    border-radius: ${theme.borderRadius.md};
    border: 2px solid ${theme.colors.black};
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: ${theme.colors.gray200};
  }

  /* Overlay system */
  .rectangle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: min(100vw, 100vh * (16 / 9));
    max-width: 100%;
    aspect-ratio: 16 / 9;
    background: transparent;
    border: 2px solid ${theme.colors.gray500};
  }

  .linkPlaceholder {
    position: absolute;
    bottom: 0%;
    left: 0%;
    background: transparent;
    z-index: ${theme.zIndex.overlay};
    width: 60%;
    height: 30%;
  }

  .linkPlaceholder:hover {
    cursor: pointer;
    background: ${theme.colors.goldRadialLink};
  }

  .bubbleLink {
    position: absolute;
    bottom: 0%;
    left: 0%;
    background: transparent;
    z-index: ${theme.zIndex.overlay};
    width: 60%;
    height: 30%;
  }

  .bubbleLink:hover {
    cursor: pointer;
    background: ${theme.colors.goldRadialLink};
  }

  .avatarHover {
    cursor: pointer;
    background-color: none;
  }

  .avatarHover:hover {
    cursor: pointer;
    background: ${theme.colors.goldRadialHover};
  }

  /* Side panel */
  .side-panel {
    position: fixed;
    top: 0;
    right: 0;
    width: min(${theme.spacing.sidebarWidth}, ${theme.spacing.sidebarWidthMobile});
    height: 100vh;
    background: ${theme.colors.overlayLight};
    box-shadow: ${theme.shadows.panel};
    transform: translateX(100%);
    transition: transform ${theme.transitions.panel};
    z-index: ${theme.zIndex.panel};
    display: flex;
    flex-direction: column;
    padding: ${theme.spacing.lg};
  }

  .side-panel.open {
    transform: translateX(0);
  }

  .side-panel .close-btn {
    align-self: flex-end;
    background: none;
    border: none;
    cursor: pointer;
  }

  .side-panel .panel-content {
    flex: 1;
    color: ${theme.colors.white};
    overflow: auto;
    line-height: ${theme.spacing.xl};
  }

  .side-panel .panel-content a {
    color: ${theme.colors.gold};
  }

  .side-panel .panel-content img {
    max-width: 100%;
    height: auto;
    margin-top: ${theme.spacing.md};
  }

  /* Keyframe animations */
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes fadeOut {
    from { opacity: 1; }
    to { opacity: 0; }
  }

  @keyframes App-logo-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  /* Prefers reduced motion */
  @media (prefers-reduced-motion: no-preference) {
    .App-logo {
      animation: App-logo-spin infinite 20s linear;
    }
  }

  /* Responsive call-me button */
  @media (max-width: 768px) {
    button.call-me-btn {
      padding-left: 12px !important;
      padding-right: 12px !important;
      width: 48px;
    }

    .call-me-text {
      display: none;
    }
  }
`;
